import { defineComponent as k, openBlock as l, createElementBlock as a, renderSlot as g, createBlock as c, createCommentVNode as o, Fragment as w, renderList as B } from "vue";
import d from "./index3.js";
const C = {
  key: 0,
  class: "modal-footer"
}, y = {
  key: 0,
  class: "modal-footer-actions"
}, b = {
  key: 1,
  class: "modal-custom-actions"
}, T = /* @__PURE__ */ k({
  __name: "ModalFooter",
  props: {
    actions: { default: () => [] },
    showDefaultFooter: { type: Boolean, default: !0 },
    cancelText: { default: "취소" },
    confirmText: { default: "확인" },
    showCancelButton: { type: Boolean, default: !0 },
    showConfirmButton: { type: Boolean, default: !0 },
    fullWidth: { type: Boolean, default: !0 }
  },
  emits: ["cancel", "confirm", "action"],
  setup(e, { emit: s }) {
    const i = s, f = () => {
      i("cancel");
    }, h = () => {
      i("confirm");
    }, m = (n, u) => {
      i("action", n, u);
    };
    return (n, u) => e.actions.length > 0 || n.$slots.default || e.showDefaultFooter ? (l(), a("footer", C, [
      g(n.$slots, "default", {}, () => [
        e.showDefaultFooter ? (l(), a("div", y, [
          e.showConfirmButton ? (l(), c(d, {
            key: 0,
            variant: "contained",
            size: "lg",
            label: e.confirmText,
            "full-width": e.fullWidth,
            "data-modal-primary-action": "true",
            onClick: h
          }, null, 8, ["label", "full-width"])) : o("", !0),
          e.showCancelButton ? (l(), c(d, {
            key: 1,
            variant: "contained",
            color: "grey",
            size: "lg",
            label: e.cancelText,
            "full-width": e.fullWidth,
            onClick: f
          }, null, 8, ["label", "full-width"])) : o("", !0)
        ])) : o("", !0),
        e.actions.length > 0 ? (l(), a("div", b, [
          (l(!0), a(w, null, B(e.actions, (t, r) => (l(), c(d, {
            key: r,
            variant: t.variant || "contained",
            size: t.size || "lg",
            label: t.label,
            disabled: t.disabled,
            "is-loading": t.loading,
            "left-icon": t.leftIcon,
            "right-icon": t.rightIcon,
            "full-width": e.fullWidth,
            onClick: (v) => m(t, r)
          }, null, 8, ["variant", "size", "label", "disabled", "is-loading", "left-icon", "right-icon", "full-width", "onClick"]))), 128))
        ])) : o("", !0)
      ])
    ])) : o("", !0);
  }
});
export {
  T as default
};
